import { defineComponent as w, ref as g, computed as i, onMounted as T, onUnmounted as h, openBlock as l, createElementBlock as o, normalizeClass as c } from "vue";
import { sanitize as v } from "../../../utils/htmlSanitizer.js";
import { getSpacingClass as y } from "../../../composables/useSpacingClass.js";
import { _ as H } from "../../../_plugin-vue_export-helper-dad06003.js";
const L = w({
  name: "VHTMLText",
  props: {
    center: {
      type: Boolean,
      default: !1
    },
    tag: {
      type: String,
      validator(e) {
        return ["p", "div", "span"].indexOf(e) !== -1;
      },
      default: "p"
    },
    size: {
      type: String,
      validator(e) {
        return ["m", "s", "xs", "xxs"].indexOf(e) !== -1;
      },
      default: "m"
    },
    bottomSpacing: {
      type: String,
      default: "",
      validator: (e) => ["s", "m", "l", "xl", ""].includes(e)
    },
    topSpacing: {
      type: String,
      default: "",
      validator: (e) => ["s", "m", "l", "xl", ""].includes(e)
    },
    color: {
      type: String,
      default: "grey-900",
      validator: (e) => [
        "grey-400",
        "grey-500",
        "grey-600",
        "grey-800",
        "grey-900",
        "white",
        "green",
        ""
      ].includes(e)
    },
    htmlText: {
      type: String,
      default: ""
    },
    class: {
      type: String,
      default: ""
    },
    router: {
      type: Object,
      required: !0,
      default: void 0
    }
  },
  setup(e) {
    const r = g(), a = g(), s = (t) => {
      var n;
      t.target.href && (t.preventDefault(), (n = e.router) == null || n.handleLink(t.target.href));
    }, u = (t) => {
      switch (t) {
        case "m":
          return "tw-text-base";
        case "s":
          return "tw-text-sm";
        case "xs":
          return "tw-text-xs";
        case "xxs":
          return "tw-text-xxs";
      }
    }, d = i(() => [
      e.class,
      u(e.size),
      e.center ? "tw-text-center" : "",
      y(e.bottomSpacing, "b"),
      y(e.topSpacing, "t"),
      e.color !== "" ? "tw-text-" + e.color.replace(/\bgrey\b/g, "gray") : ""
    ]), f = i(() => {
      var m, p;
      const t = ((m = a.value) == null ? void 0 : m.getElementsByTagName("a")) ?? [], n = ((p = r.value) == null ? void 0 : p.getElementsByTagName("a")) ?? [];
      return Array.from(t).concat(Array.from(n));
    }), x = i(() => v(e.htmlText || "", null));
    return T(() => {
      f.value.forEach(
        (t) => t.addEventListener("click", s)
      );
    }), h(() => {
      f.value.forEach(
        (t) => t.removeEventListener("click", s)
      );
    }), {
      heyObiDivTextRef: a,
      heyObiPTextRef: r,
      cssClass: d,
      sanitizedHtmlText: x
    };
  }
}), S = ["innerHTML"], b = ["innerHTML"], k = ["innerHTML"];
function z(e, r, a, s, u, d) {
  return e.tag === "div" ? (l(), o("div", {
    key: 0,
    class: c(["tw-font-sans tw-not-italic tw-whitespace-pre-wrap tw-m-0", e.cssClass]),
    innerHTML: e.sanitizedHtmlText,
    ref: "heyObiDivTextRef"
  }, null, 10, S)) : e.tag === "span" ? (l(), o("span", {
    key: 1,
    class: c(["tw-font-sans tw-not-italic tw-whitespace-pre-wrap tw-m-0", e.cssClass]),
    innerHTML: e.sanitizedHtmlText,
    ref: "heyObiDivTextRef"
  }, null, 10, b)) : (l(), o("p", {
    key: 2,
    class: c(["tw-font-sans tw-not-italic tw-whitespace-pre-wrap tw-m-0", e.cssClass]),
    innerHTML: e.sanitizedHtmlText,
    ref: "heyObiPTextRef"
  }, null, 10, k));
}
const _ = /* @__PURE__ */ H(L, [["render", z]]);
export {
  _ as default
};
